module.exports = {
    tag: 'stinking',
    quality: 0,
    perception: -1,
    mana: -1
};